import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: {},
  state: {},
};

const eidtUserSlice = createSlice({
  name: "editUser",
  initialState,
  reducers: {
    setEditUser: (state, action) => {
      state.user = action.payload;
    },
    setUserState: (state, action) => {
      state.state = action.payload;
    },
  },
});

export const { setEditUser,setUserState, setUpdatedEditUser } = eidtUserSlice.actions;
export default eidtUserSlice.reducer;
